import COMMON_TYPES from '../../../actions/types';
//import { details } from '../../../api/common';

export const toggleInsightsLayer = params => {
  if(params && params.id) {
    return async dispatch => {
      try {
        dispatch({
          type: COMMON_TYPES.toggleLayer,
          payload: 'insights',
        });

        const result = {}; // await details({ id: params.id, path: 'parliamentary.amendment.php' });

        dispatch({
          type: COMMON_TYPES.detailsGetResult,
          payload: result,
        });
      }
      catch (responseFail) {
        console.log(responseFail);
        return dispatch({ type: COMMON_TYPES.detailsGetResultError });
      }
    }
  }

  return [
    { type: COMMON_TYPES.toggleLayer, payload: null },
    { type: COMMON_TYPES.detailsGetResult, payload: { data: null } }
  ];
};
